import { Undo2 } from "lucide-react";
import { useEffect, useState } from "react";

import BlocoRecolhivel from "./BlocoRecolhivel";
import Chave from "./Chave";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

// Desfazer no KDS (pedido do dono, 03/10/2026): depois de cada ação da tela da
// cozinha ou do garçom, a ação fica 10 s em espera com o botão Desfazer na
// tela, para corrigir toque por engano. Nasce ligado em toda loja; esta chave
// desliga (a loja que prefere tudo valendo na hora, como era antes).
export default function KdsDesfazerPreferencias({ toast }) {
  const [ligado, setLigado] = useState(null); // null = carregando
  useEffect(() => {
    fetch(`${API_URL}/api/settings/kds`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => setLigado(d.desfazer !== false))
      .catch(() => setLigado(true));
  }, []);

  const alternar = async () => {
    const novo = !ligado;
    setLigado(novo);
    try {
      const r = await fetch(`${API_URL}/api/settings/kds`, { method: "PUT", headers: auth(), body: JSON.stringify({ desfazer: novo }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
      toast({
        title: novo ? "Desfazer do KDS ligado" : "Desfazer do KDS desligado",
        description: novo
          ? "Cada ação do KDS espera 10 segundos antes de valer, com o botão Desfazer na tela. As telas abertas acompanham em até 1 minuto."
          : "As ações do KDS voltam a valer na hora, sem o botão Desfazer. As telas abertas acompanham em até 1 minuto.",
      });
    } catch (e) {
      setLigado(!novo);
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  return (
    <BlocoRecolhivel e2e="card-kds-desfazer" icone={Undo2} titulo="Desfazer no KDS"
      carregando={ligado === null}
      resumo={ligado === null ? "Carregando…" : ligado ? "Ligado — 10 segundos para desfazer a última ação" : "Desligado — as ações valem na hora"}
      controle={<Chave ligado={!!ligado} onAlternar={alternar} desabilitado={ligado === null} id="sw-kds-desfazer" />}>
      <p className="text-sm text-muted-foreground">
        Depois de cada ação na tela da cozinha ou do garçom (marcar pronto, concluir, entregar, chamar entregador), o botão
        <strong> Desfazer</strong> fica 10 segundos na tela, para corrigir toque por engano. Enquanto o tempo corre, a ação
        aparece só no aparelho de quem tocou: o garçom, o WhatsApp do cliente, o entregador e o caixa são avisados quando os
        10 segundos acabam ou quando a pessoa faz a próxima ação. Desligado, tudo vale na hora, sem o botão.
      </p>
    </BlocoRecolhivel>
  );
}
